import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function AdditionalRequirementList() {
  const navigate = useNavigate();
  const columns = [
    { field: "ARL_Id", label: "#" },
    { field: "ARL_Name", label: "Additional Requirement" },
    { field: "ARL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const rowsPerPage = searchParams.get("rowsPerPage");

  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.ARL_Id));

        navigate(
          `/AdditionalRequirementsLookup/Edit/${encrypted}?page=${page}&rowsPerPage=${rowsPerPage}`
        );
      },
      color: "warning",
    },
  ];
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/AdditionalRe/list`}
      actions={actions}
      title={`Additional Requirements`}
      linkvalue={`/AdditionalRequirementsLookup/Add?page=${page}&rowsPerPage=${rowsPerPage}`}
    />
  );
}

export default AdditionalRequirementList;
